interface DownArrowIconProps {
  clicked?: boolean;
  color?: string;
}
const DownArrowIcon = ({ clicked, color }: DownArrowIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 13" fill="none">
    <path
      d="M0.75 3.62L6 9.5L11.25 3.62"
      stroke={clicked ? "#FFF" : color ? color : "#002035"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownArrowIcon;
